export const SUPPORTED_SAFE_CHAIN = {
  1: "eth",
  4: "rin",
};
